import { useEffect, useMemo, useState } from "react";
import { Search } from "lucide-react";
import { api } from "@/lib/api";
import { Loader } from "@/components/Common";
import { UserCard } from "@/components/UserCard";

const SORTS = {
  recenti: { label: "Più recenti", fn: (a, b) => (b.created_at || "").localeCompare(a.created_at || "") },
  meno: { label: "Meno recenti", fn: (a, b) => (a.created_at || "").localeCompare(b.created_at || "") },
  cognome: { label: "Cognome A-Z", fn: (a, b) => (a.last_name || a.name || "").localeCompare(b.last_name || b.name || "", "it") },
};

export default function ProUsers() {
  const [data, setData] = useState(null);
  const [q, setQ] = useState("");
  const [sort, setSort] = useState("recenti");
  useEffect(() => { api.get("/admin/users").then(({ data }) => setData(data)); }, []);

  const shown = useMemo(() => {
    if (!data) return [];
    const s = q.trim().toLowerCase();
    return data.users
      .filter((u) => !s || [u.first_name, u.last_name, u.email, u.name].some((v) => (v || "").toLowerCase().includes(s)))
      .sort(SORTS[sort].fn);
  }, [data, q, sort]);

  if (!data) return <Loader />;
  const update = (row) => setData({ ...data, users: data.users.map((u) => (u.user_id === row.user_id ? row : u)) });

  return (
    <div className="space-y-5 px-5 py-6" data-testid="pro-users-page">
      <div>
        <p className="eyebrow">Area riservata</p>
        <h1 className="font-serif text-4xl font-semibold text-[#0D2517]">Utenti</h1>
        <p className="mt-1 text-sm text-[#5b6b60]">Utenti registrati: <strong data-testid="users-total">{data.total}</strong></p>
      </div>
      <div className="relative">
        <Search size={16} className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-[#8a958d]" />
        <input className="field !pl-9" placeholder="Cerca per nome, cognome o email" value={q} onChange={(e) => setQ(e.target.value)} data-testid="users-search-input" />
      </div>
      <div className="grid grid-cols-3 gap-2">
        {Object.entries(SORTS).map(([k, v]) => (
          <button key={k} onClick={() => setSort(k)} className={`chip ${sort === k ? "chip-on" : ""}`} data-testid={`users-sort-${k}`}>{v.label}</button>
        ))}
      </div>
      {shown.length === 0 && <p className="text-center text-sm text-[#5b6b60]" data-testid="users-empty">Nessun utente trovato.</p>}
      {shown.map((u) => <UserCard key={u.user_id} u={u} onChange={update} />)}
    </div>
  );
}
